<script setup>
const props = defineProps({
  coin: {
    type: Object,
    default: [],
  },
});

const { formatMoneyWithCurrency, moneyFormater } = useMoneyFormater();

function countApsar(count) {
  if (count === 1) {
    return "апсар";
  } else if ((count > 1) & (count < 5)) {
    return "апсара";
  } else {
    return "апсаров";
  }
}
</script>

<template>
  <div class="flex flex-col space-y-3 lg:space-y-0 lg:flex-row lg:space-x-10">
    <div class="w-full lg:w-112 shrink-0 flex flex-col">
      <div
        class="w-full flex flex-row border-b pt-[10px] pb-[10px] border-[#F3F3F7] space-x-3 justify-between"
      >
        <p class="font-sans text-sm md:text-base text-[#6B6B6B]">
          Год выпуска:
        </p>
        <p class="text-[#333333] text-sm md:text-base text-right font-sans">
          {{ coin.year_of_release }}
        </p>
      </div>
      <div
        class="flex flex-row border-b pt-[10px] pb-[10px] border-[#F3F3F7] space-x-3 justify-between"
      >
        <p class="font-sans text-sm md:text-base text-[#6B6B6B]">Номинал:</p>
        <p class="text-[#333333] text-sm md:text-base text-right font-sans">
          {{ coin.denomination }} {{ countApsar(coin.denomination) }}
        </p>
      </div>
      <div
        class="flex flex-row border-b pt-[10px] pb-[10px] border-[#F3F3F7] space-x-3 justify-between"
      >
        <p class="font-sans text-sm md:text-base text-[#6B6B6B]">Качество:</p>
        <p class="text-[#333333] text-sm md:text-base text-right font-sans">
          {{ coin.quality }}
        </p>
      </div>
      <div
        class="flex flex-row border-b pt-[10px] pb-[10px] border-[#F3F3F7] space-x-3 justify-between"
      >
        <p class="font-sans text-sm md:text-base text-[#6B6B6B]">
          Металл, проба:
        </p>
        <p class="text-[#333333] text-sm md:text-base text-right font-sans">
          {{ coin.metal }}
        </p>
      </div>
      <div
        class="flex flex-row border-b pt-[10px] pb-[10px] border-[#F3F3F7] space-x-3 justify-between"
      >
        <p class="font-sans text-sm md:text-base text-[#6B6B6B]">Масса:</p>
        <p class="text-[#333333] text-sm md:text-base text-right font-sans">
          {{ coin.weight }} г
        </p>
      </div>
      <div
        class="flex flex-row border-b pt-[10px] pb-[10px] border-[#F3F3F7] space-x-3 justify-between"
      >
        <p class="font-sans text-sm md:text-base text-[#6B6B6B]">
          Содержание чистого металла не менее:
        </p>
        <p class="text-[#333333] text-sm md:text-base text-right font-sans">
          {{ coin.metal_content }} г
        </p>
      </div>
      <div
        class="flex flex-row border-b pt-[10px] pb-[10px] border-[#F3F3F7] space-x-3 justify-between"
      >
        <p class="font-sans text-sm md:text-base text-[#6B6B6B]">Диаметр:</p>
        <p class="text-[#333333] text-sm md:text-base text-right font-sans">
          {{ coin.diameter }} мм
        </p>
      </div>
      <div
        class="flex flex-row border-b pt-[10px] pb-[10px] border-[#F3F3F7] space-x-3 justify-between"
      >
        <p class="font-sans text-sm md:text-base text-[#6B6B6B]">Толщина:</p>
        <p class="text-[#333333] text-sm md:text-base text-right font-sans">
          {{ coin.thickness }} ± 0,2 мм
        </p>
      </div>
      <div
        class="flex flex-row border-b pt-[10px] pb-[10px] border-[#F3F3F7] space-x-3 justify-between"
      >
        <p class="font-sans text-sm md:text-base text-[#6B6B6B]">Тираж:</p>
        <p class="text-[#333333] text-sm md:text-base text-right font-sans">
          до {{ coin.circulation }} шт.
        </p>
      </div>
    </div>
    <div class="flex flex-col pt-2.5 md:pt-0 space-y-6">
      <div>
        <p class="font-firasans pb-3 text-xl">Аверс</p>
        <div
          class="font-sans text-base !leading-5"
          v-html="coin.obverse_description.text"
        ></div>
      </div>
      <div>
        <p class="font-firasans pb-3 text-xl">Реверс</p>
        <div
          class="font-sans text-base !leading-5"
          v-html="coin.reverse_description.text"
        ></div>
      </div>
    </div>
  </div>
</template>
